export default __webpack_public_path__ + "static/media/CNo.83-7.970a9bc9.jpg";